import axios from 'axios';
import { REGISTER_SUCCESS, REGISTER_FAIL, USER_LOADED, AUTH_ERROR, LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT, RECUPERA_PASSWORD, CHECK_TOKEN, MODIFICA_PASSWORD, MODIFICA_PROFILO, GET_UTENTI, AGGIUNGI_UTENTE, MODIFICA_UTENTE, GET_UTENTE, CLEAN_DATI_DASHBOARD, UTENTE_ERROR } from './types';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken';
import { setSidebarPosition } from '../actions/sidebar'

export const loadUser = () => async dispatch => {
    if(localStorage.token){
        setAuthToken(localStorage.token);
    }

    try{
        const res = await axios.get('/api/auth');
        dispatch({
            type: USER_LOADED,
            payload: res.data
        });
    }catch(err){
        dispatch({
            type: AUTH_ERROR
        });
    }
}

export const register = ({ username, password, nome, cognome }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ username, password, nome, cognome });
    try{
        const res = await axios.post('/api/auth/register', body, config);
        dispatch({
            type: REGISTER_SUCCESS,
            payload: res.data
        });

        dispatch(loadUser());


    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        
        dispatch({
            type: REGISTER_FAIL
        });
    }
};



export const login = ({ username, password, codiceDispositivo}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ username, password, codiceDispositivo });
    try{
        const res = await axios.post('/api/auth', body, config);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        });
        dispatch(loadUser());        
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        
        dispatch({
            type: LOGIN_FAIL
        });
    }
};

export const registraUtente = ({ username, password, codiceDispositivo}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ username, password, codiceDispositivo });
    try{
        const res = await axios.post('/api/auth/registraUtente', body, config);
        dispatch({
            type: REGISTER_SUCCESS,
            payload: res.data
        });
        dispatch(loadUser());        
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        
        dispatch({
            type: LOGIN_FAIL
        });
    }
};

export const loginUtente = ({ username, password, codiceDispositivo }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ username, password, codiceDispositivo });
    try{
        const res = await axios.post('/api/auth/loginUtente', body, config);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        });
        dispatch(loadUser());        
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        
        dispatch({
            type: LOGIN_FAIL
        });
    }
};

export const checkToken = ({ token }) => async dispatch => {
    try{
        const res = await axios.get(`/api/auth/checkToken/${token}`);
        dispatch({
            type: CHECK_TOKEN,
            payload: res.data
        });
        if(!res.data){
            dispatch(setAlert("", 'redirect'))
        }
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        
        dispatch({
            type: AUTH_ERROR
        });
    }
};


export const modificaPassword = ({ token, password }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ token, password });
    try{
        const res = await axios.post('/api/auth/modificaPassword', body, config);
        dispatch({
            type: MODIFICA_PASSWORD,
            payload: res.data
        });
        dispatch(setAlert("Password modificata con successo!", 'success'))
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AUTH_ERROR
        });
    }
}

export const recuperaPassword = ({ email}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ email });
    try{
        const res = await axios.post('/api/auth/recuperaPassword', body, config);
        dispatch({
            type: RECUPERA_PASSWORD,
            payload: res.data
        });
        dispatch(setAlert("Richiesta inviata con successo!", 'success'))
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        
        dispatch({
            type: AUTH_ERROR
        });
    }
};

export const modificaProfilo = ({ username, email }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ username, email });
    try{
        const res = await axios.post('/api/auth/modificaProfilo', body, config);
        dispatch({
            type: MODIFICA_PROFILO,
            payload: res.data
        });
        dispatch(setAlert("Profilo modificato con successo!", 'success'))
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: UTENTE_ERROR
        });
    }
}


export const getUtenti = () => async dispatch => {
    try{
        const res = await axios.get('/api/auth/getUtenti');
        dispatch({
            type: GET_UTENTI,
            payload: res.data
        });
    }catch(err){
        dispatch({
            type: UTENTE_ERROR
        });
    }
}

export const aggiungiUtente = ({ username, email, ruolo, password }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ username, email, ruolo, password });
    try{
        const res = await axios.post('/api/auth/aggiungiUtente', body, config);
        dispatch({
            type: AGGIUNGI_UTENTE,
            payload: res.data
        });

        dispatch(setAlert("Utente aggiunto con successo!", 'success'))

    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: UTENTE_ERROR
        });
    }
};

export const getUtente = ({ idUtente }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ idUtente });
    try{
        const res = await axios.post('/api/auth/getUtente', body, config);
        dispatch({
            type: GET_UTENTE,
            payload: res.data
        });

    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: UTENTE_ERROR
        });
    }
};

export const modificaUtente = ({ idUtente, username, email, ruolo, nuova_password, ripeti_password }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ idUtente, username, email, ruolo, nuova_password, ripeti_password });
    try{
        const res = await axios.post('/api/auth/modificaUtente', body, config);
        dispatch({
            type: MODIFICA_UTENTE,
            payload: res.data
        });

        dispatch(setAlert("Utente modificato con successo!", 'success'))

    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: UTENTE_ERROR
        });
    }
};

export const modificaPasswordProfilo = ({ nuova_password, ripeti_password }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ nuova_password, ripeti_password });
    try{
        const res = await axios.post('/api/auth/modificaPasswordProfilo', body, config);
        dispatch({
            type: MODIFICA_PROFILO,
            payload: res.data
        });

        dispatch(setAlert("Password modificata con successo!", 'success'))

    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: UTENTE_ERROR
        });
    }
};


export const logout = () => dispatch => {
    dispatch({ type: LOGOUT });
    dispatch({ type: CLEAN_DATI_DASHBOARD });
    setAuthToken(null);
    dispatch(setSidebarPosition('admin', 'ordini'));
};

export const displayMessageLogin = (msg, type) => dispatch => {
    dispatch(setAlert(msg, type))
};